import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  plugins: [
    createPersistedState()
  ],
  state: {
    token: null,
    user: null,
    isUserLoggedIn: false,
    permission: null,
    customerId: null,
    orgToken: null,
    organisations: [],
    currentOrg: null,
    orgPermission: null,
    currentRoute: null,
    userOrg: null
  },
  mutations: {
    setToken (state, token) {
      state.token = token
      state.isUserLoggedIn = !!(token)
      //state.isUserLoggedIn=true
    },
    setOrgToken (state, orgToken) {
      state.orgToken = orgToken
      // state.isUserLoggedIn = !!(orgToken)
      //state.isUserLoggedIn=true
    },
    setOrganisations(state, orgs){
      state.organisations=orgs
    },
    setCurrentOrg(state, org){
      state.currentOrg=org
    },
    setUserOrg(state, org){
      state.userOrg=org
    },
    setCurrentOrgPermission(state, orgPermission){
      state.currentOrgPermission=orgPermission
    },
    setCurrentRoute(state, route){
      state.currentRoute=route
    },
    setUser (state, user) {
      state.user = user
    },
    setPermission (state, permission) {
      state.permission = permission
    },
    setCustomerId (state, customerId) {
      state.customerId = customerId
    },
    setIsUserLoggedIn (state, isUserLoggedIn) {
      state.isUserLoggedIn = isUserLoggedIn
    }
  },
  actions: {
    setToken ({commit}, token) {
      commit('setToken', token)
    },
    setOrgToken ({commit}, orgToken) {
      commit('setOrgToken', orgToken)
    },
    setOrganisations({commit}, orgs) {
      commit('setOrganisations', orgs)
    },
    setCurrentOrg({commit}, org) {
      commit('setCurrentOrg', org)
    },
    setUserOrg({commit}, org) {
      commit('setUserOrg', org)
    },
    setCurrentOrgPermission({commit}, orgPermission) {
      commit('setCurrentOrgPermission', orgPermission)
    },
    setCurrentRoute({commit}, route) {
      commit('setCurrentRoute', route)
    },
    setUser ({commit}, user) {
      commit('setUser', user)
    },
    setPermission ({commit}, permission) {
      commit('setPermission', permission)
    },
    setCustomerId ({commit}, customerId) {
      commit('setCustomerId', customerId)
    },
    setIsUserLoggedIn ({commit}, isUserLoggedIn) {
      commit('setIsUserLoggedIn', isUserLoggedIn)
    },
  }
})
